import React from "react";
import moment from "moment";
import { ViewClient } from "./actionButtons/ViewClient";
import { DeleteClient } from "./actionButtons/DeleteClient";
import { DisplayUserOrganizations } from "../../../shared/DisplayUserOrganizations";
import { TRANSLATED_USER_STATUSES, USER_STATUSES } from "../../../../config/constants";
import { LockClient } from "./actionButtons/LockClient";
import { UnlockClient } from "./actionButtons/UnlockClient";
import { ResetPasswordClient } from "./actionButtons/ResetPasswordClient";
import { SendEmailClient } from "./actionButtons/SendEmailClient";

function TableRow(props) {
  const { user, index } = props;

  if (! user) {
    return null;
  }

  return (
    <tr>
      <td>{moment(user.created_at).format('lll')}</td>
      <td className="w-10">{user.first_name}</td>
      <td className="w-10">{user.last_name}</td>
      <td className="w-10">{user.email}</td>
      <td><DisplayUserOrganizations user={user}/></td>
      <td>{TRANSLATED_USER_STATUSES[user.status]}</td>
      <td className="w-10">
        <ViewClient
          user={user}
          index={index}
        />
        <SendEmailClient
          user={user}
          index={index}
          showIcon={true}
          actionCallback={() => props.actionCallback( true )}
        />
        <DeleteClient
          user={user}
          index={index}
          showIcon={true}
          actionCallback={() => props.actionCallback( true )}
        />
        {
          user.status === USER_STATUSES.DEACTIVATED ?
          <UnlockClient
            user={user}
            index={index}
            showIcon={true}
            actionCallback={() => props.actionCallback( true )}
          /> :
          <LockClient
            user={user}
            index={index}
            showIcon={true}
            actionCallback={() => props.actionCallback( true )}
          />
        }
        <ResetPasswordClient
          user={user}
          index={index}
          showIcon={true}
          actionCallback={() => props.actionCallback( true )}
        />
      </td>
    </tr>
  );
}

TableRow.defaultProps = {
  user: null,
};

export { TableRow };
